import fileService from "api/fileService";
import keysService from "api/keysService";
import AddButton from "components/AddButton";
import Button from "components/Button";
import Filedossier from "components/Filedossier/Filedossier";
import useFiles from "hooks/useFiles";
import { useRef, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { handleCreate } from "utils/uploadFile";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import DossierAnimation from "components/DossierAnimation";
import CloseIcon from "assets/icons/close.svg?react";
import DropdownMui from "components/DropdownMui";
import { IDropdownObject } from "components/Dropdown/typings";
import adminService from "api/adminService";
import { useTranslation } from "react-i18next";

export const getAttachmentTypes = (
  t: (key: string) => string
): IDropdownObject[] => {
  return [
    {
      value: 0,
      name: t("dossier.other"),
    },
    {
      value: 1,
      name: t("admin.krsExtract"),
    },
  ];
};

const AddAttachmentModal: FC<Props> = ({
  addressBookVerificationId,
  toggle,
  reload,
}) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const { files, addNewFile, removeFile, setFiles } = useFiles();
  const inputFile = useRef<HTMLInputElement | null>(null);

  const { isLoading: loadingObject } = keysService.useCreateObject();
  const { isLoading: loadingInit } = fileService.useInitUpload();
  const { isLoading: loadingS3 } = fileService.useGetS3();
  const { isLoading: loadingConfirm } = fileService.useConfirmUpload();
  const { mutate: addAttachment, isLoading: loadingAdd } =
    adminService.useAddAddressBookVerificationAttachment();

  const handleClickCloseModal = () => toggle(false);

  const handleClickToUpload = () => {
    if (!inputFile.current) return;
    inputFile.current.click();
  };

  const handleChooseFile = async (event: any) => {
    event.stopPropagation();
    event.preventDefault();
    const file = (event.target as any).files[0];
    if (!file) return;

    addNewFile(file);
  };

  const [actualFile] = useState(0);
  const [actualProgress, setActualProgress] = useState<number | null>(null);
  const [type, setType] = useState<number | null>(null);

  const handleCreatee = async () => {
    for (const file of files) {
      const r = await handleCreate(
        [file],
        null,
        null,
        false,
        false,
        undefined,
        undefined,
        (fileIndex: number, progress: number) => {
          setActualProgress(progress);
        }
      );

      if (!r) {
        return;
      }

      addAttachment(
        {
          ContactFormAddressBookVerificationId: addressBookVerificationId,
          Uri: r[0].uri,
          Type: type,
        },
        {
          onSuccess: () => {
            reload();
            handleClickCloseModal();
          },
          onError: () => setIsLoading(false),
        }
      );
    }
  };

  const handleRemove = (index: number) => removeFile(index);

  const Attachments = () => {
    return (
      <>
        {!files.length ? (
          <FileUploader
            multiple={true}
            handleChange={async (f: any) => {
              const newFiles = Array.from(f).map((f) => f) as File[];
              setFiles([...files, newFiles].flat());
            }}
            classes={styles.drop}
            dropMessageStyle={{
              opacity: 0,
            }}
            name="file"
            children={
              <div className={styles.emptyAttachments}>
                <DossierAnimation className={styles.noFiles} />
                <div className={styles.emptyButtons}>
                  {t("common.dragAndDrop")}
                  <div className={styles.buttonCTA}>
                    {t("common.chooseFromDisk")}
                  </div>
                </div>
              </div>
            }
          />
        ) : (
          <div className={styles.attachmentsWrapper}>
            <AddButton
              className={styles.add}
              onClick={handleClickToUpload}
              text={t("common.addFile")}
            />
            <div className={styles.attachments}>
              {files.map((file: File, index: number) => (
                <Filedossier
                  key={index}
                  index={index}
                  handleRemove={handleRemove}
                  file={file}
                  actualFile={actualFile}
                  actualProgress={actualProgress}
                />
              ))}
            </div>
          </div>
        )}
      </>
    );
  };

  const [showErrors, setShowErrors] = useState({ case: false, files: false });

  const isButtonActive = () => {
    const isSendingFilesOrLink =
      loadingObject || loadingInit || loadingS3 || loadingConfirm || loadingAdd;

    if (isSendingFilesOrLink) {
      return true;
    }

    if (type === null) {
      return true;
    }
    return false;
  };

  const handleError = () => {
    const payload = {
      case: false,
      files: false,
    };

    setShowErrors(payload);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        {t("documents.addAttachment")}
        <CloseIcon
          onClick={handleClickCloseModal}
          className={styles.closeIcon}
        />
      </div>
      <div className={styles.content}>
        <DropdownMui
          list={getAttachmentTypes(t)}
          label={t("documents.attachmentType")}
          placeholder={t("documents.attachmentTypePlaceholder")}
          allowNull={false}
          defaultValue={0}
          onChange={(r) => setType(r.value as number)}
        ></DropdownMui>
        <Attachments />
        {showErrors.files && (
          <div className={styles.error}>{t("documents.chooseFiles")}</div>
        )}
      </div>
      <div className={styles.footer}>
        <Button
          className={styles.button}
          onClick={handleCreatee}
          text={t("common.add")}
          loading={isLoading}
          handleError={handleError}
          disabled={isButtonActive()}
        />
      </div>

      <input
        type="file"
        id="file"
        ref={inputFile}
        style={{ display: "none" }}
        onChange={handleChooseFile}
      />
    </div>
  );
};

export default AddAttachmentModal;
